// extracted by mini-css-extract-plugin
export default {"DleGeneralInfo":"DleGeneralInfo_DleGeneralInfo__2py++"};